import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/windows': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 93.7l183.6-25.3v177.4h-183.6v-152.1zM0 418.3v-149.9h183.6v175.2zM203.8 446.3v-177.9h244.2v211.6zM203.8 65.7l244.2-33.7v213.8h-244.2v-180.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/windows.js
// module id = 1095
// module chunks = 0